import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import registerServiceWorker from './registerServiceWorker';
import { startFrontendUpdates } from './utils/frontendUpdates';
import FrontendUpdateModal from './components/generics/FrontendUpdateModal';
import "./scss/style.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));
// Keep the local comparison outside auth/store initialization and production builds.
const isProductionUIPreview = process.env.NODE_ENV === 'development'
  && ['/__ui/production', '/__ui/app', '/__ui/fifo'].includes(window.location.pathname);
let RootComponent;
if (process.env.NODE_ENV === 'development' && isProductionUIPreview) {
  RootComponent = window.location.pathname === '/__ui/fifo'
    ? require('./dev/FifoFlowsPreview').default
    : window.location.pathname === '/__ui/app'
    ? require('./dev/AppUIComparison').default
    : require('./dev/ProductionUIComparison').default;
} else {
  RootComponent = require('./App').default;
}
root.render(
  <React.StrictMode>
    <RootComponent />
    {!isProductionUIPreview && <FrontendUpdateModal />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
if (!isProductionUIPreview) registerServiceWorker();
if (process.env.NODE_ENV === 'production') startFrontendUpdates();
